import React, { memo, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@/store'
import { scrollTo } from '@/utils/ui-helper'
import { PannelWrapper } from './style'

export default memo(function LyricPanel() {
    const { lyricList, currentLyricIndex } = useSelector((state: RootState) => ({
        lyricList: state.player.lyricList,
        currentLyricIndex: state.player.currentLyricIndex,
    }))

    const panelRef = useRef(null)
    useEffect(() => {
        // 滚动歌词
        if (currentLyricIndex > 0 && currentLyricIndex < 3) return
        scrollTo(panelRef.current, (currentLyricIndex - 3) * 32, 300)
    }, [currentLyricIndex])

    return (
        <PannelWrapper ref={panelRef}>
            <div className="lrc-content">
                {lyricList?.map((item, index) => {
                    return (
                        <div key={item.time} className={`lrc-item ${index === currentLyricIndex ? 'active' : ''}`}>
                            {item.content}
                        </div>
                    )
                })}
            </div>
        </PannelWrapper>
    )
})
